import type { BrandListQuery } from '@/api/handlers/resources/brands/requests';

/**
 * Centralised TanStack Query keys for the Brands resource. Sharing the keys
 * here keeps mutations and queries from drifting out of step when one is
 * invalidated and the other is read.
 *
 * `list()` is the prefix that covers every paginated page; `listPage` adds the
 * query params so each page/search is its own cache entry. Write mutations
 * invalidate the `list()` prefix so all cached pages refetch.
 */
export const BrandQueryKeys = {
    all: ['brands'] as const,
    list: () => [...BrandQueryKeys.all, 'list'] as const,
    listPage: (query: BrandListQuery) =>
        [...BrandQueryKeys.list(), query] as const,
    /** Every brand at once (`useAllBrandsQuery`), under the same prefix. */
    allItems: () => [...BrandQueryKeys.list(), 'all'] as const,
};
